'use strict';

SwaggerEditor.directive('onReadFile', ['$parse', function($parse) {
  return {
    restrict: 'A',
    scope: false,
    link: function(scope, element, attrs) {
      var fn = $parse(attrs.onReadFile);

      element.on('change', function(onChangeEvent) {
        var reader = new FileReader();

        reader.onload = function(onLoadEvent) {
          scope.$apply(function() {
            fn(scope, {$fileContent: onLoadEvent.target.result});
          });
        };

        reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target)
          .files[0]);
      });
    }
  };
}]);



//////////////////
// WEBPACK FOOTER
// ./scripts/directives/on-file-change.js
// module id = 423
// module chunks = 0